/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useContext, useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import {
  ERROR_CODES,
  PaginationState,
  WithChildren,
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  stringifyRequestQuery,
} from "src/helpers";

import { useQueryRequest } from "./QueryRequestProvider";

import { getTSCConsumptionReportList } from "src/services/requests/Report";

const QueryResponseContext = createResponseContext<any>(initialQueryResponse);
const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { state } = useQueryRequest();
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state));
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state]);

  // useEffect(() => {
  //   updateState({
  //     filter: {
  //       commentsDate: `${dayjs().subtract(1,'day').format("YYYY-MM-DD")}:${dayjs().format("YYYY-MM-DD")}`
  //     }
  //   })
  //   return () => { }
  // }, [])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery);
    }
  }, [updatedQuery]);

  const {
    isFetching,
    refetch,
    data: response,
  } = useQuery(
    `OA-LIST-REPORT-DATA-${query}`,
    async () => {
      return await getTSCConsumptionReportList(query);
    },
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      // refetchOnReconnect: false,
      // retry: false,
      //  staleTime: 5000,
    }
  );

  let responseData: any = useMemo(() => response, [response]);

  let isError = useMemo(() => (ERROR_CODES.includes(responseData?.code) ? true : false), [responseData]);
  let message = useMemo(() => (ERROR_CODES.includes(responseData?.code) ? responseData?.message : ""), [responseData]);

  return (
    <QueryResponseContext.Provider value={{ isLoading: isFetching, refetch, query, isError, message, response }}>
      {children}
    </QueryResponseContext.Provider>
  );
};

const useQueryResponse = () => useContext(QueryResponseContext);

const useQueryResponseData = () => {
  const { response }: any = useQueryResponse();
  if (!response) {
    return [];
  }

  return response?.data?.data || [];
};

const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  };

  const { response }: any = useQueryResponse();

  if (!response || !response?.data?.pagination) {
    return defaultPaginationState;
  }

  return response?.data?.pagination;
};

const useQueryResponseLoading = (): boolean => {
  const { isLoading } = useQueryResponse();
  return isLoading;
};

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
  useQueryResponsePagination,
};
